export const ROOT = '/login';
export const MODULE = 'login';
